"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderEstimatedDurationInMins = getOrderEstimatedDurationInMins;
function getOrderEstimatedDurationInMins(order) {
    if (!order.travelEstimates) {
        return;
    }
    // Roundtrips
    if (order.originLocationId === order.destinationLocationId) {
        return order.travelEstimates.travelTimeMinutes + order.travelEstimates.timeAtLocationsMinutes;
    }
    return (order.travelEstimates.travelTimeMinutes +
        order.travelEstimates.travelTimeWaybackMinutes +
        order.travelEstimates.timeAtLocationsMinutes);
}
//# sourceMappingURL=getOrderEstimatedDurationInMins.js.map